import React from "react";

const TopRoutes = () => {
  return (
    <section
      className="travel-guides bg-second-theme-color position-relative space"
      style={{
        backgroundImage: `url('/img/bg/travel-guides-bg.png')`,
      }}
    >
      <img
        src="/img/icons/plain-sclation.png"
        alt="icon"
        className="travel-guides-icon-1 animate-parachute"
      />
      <img
        src="/img/icons/rops.png"
        alt="icon"
        className="travel-guides-icon-2 animate-parachute"
      />
      <div className="container py-3">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle fade-anim" data-direction="bottom">
                Popular Routes
              </span>
              <h2
                className="sec-title text-white-color fade-anim text-white"
                data-direction="top"
              >
                Top Routes We Serve
              </h2>
            </div>
          </div>
        </div>
        <div className="row g-4">
          {[
            {
              title: "Pune to Shirdi",
              price: "Starting from ₹3499",
              img: "/images/keyword/2.jpg",
            },
            {
              title: "Pune to Mahabaleshwar",
              price: "Starting from ₹2799",
              img: "/images/keyword/36.jpg",
            },
            {
              title: "Pune to Goa",
              price: "Starting from ₹6999",
              img: "/images/keyword/55.jpg",
            },
            {
              title: "Pune to Mumbai Airport",
              price: "Starting from ₹1999",
              img: "/images/keyword/66.jpg",
            },
          ].map((route, index) => (
            <div
              className="col-md-6 col-lg-4 col-xl-3 fade-anim"
              data-delay={`0.${index + 3}0`}
              data-direction="bottom"
              key={route.title}
            >
              <div className="guide-box">
                <figure className="guide-thumb">
                  <img
                    src={route.img}
                    alt={route.title}
                    className="w-100"
                  />
                </figure>
                <div className="guide-content text-center">
                  <h5 className="guide-name text-second-theme-color text-capitalize">
                    {route.title}
                  </h5>
                  <p className="guide-designation text-theme-color text-capitalize">
                    {route.price}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopRoutes;
